import { Locale } from "@msys/tolgee";
import React from "react";
import { ReactComponent as DEFlag } from "./flags/de.svg";
import { ReactComponent as ENFlag } from "./flags/en.svg";
import { ReactComponent as FRFlag } from "./flags/fr.svg";
import { ReactComponent as NLFlag } from "./flags/nl.svg";
import { ReactComponent as PLFlag } from "./flags/pl.svg";
import { ReactComponent as RUFlag } from "./flags/ru.svg";

export interface Language {
  locale: Locale;
  language_name: string;
  flag: React.ElementType;
  countryCode: string;
  countryName: string;
}

const enGB: Language = {
  locale: "en-GB",
  language_name: "English",
  flag: ENFlag,
  countryCode: "GBR",
  countryName: "Great Britain",
};
const de: Language = {
  locale: "de",
  language_name: "Deutsch",
  flag: DEFlag,
  countryCode: "DEU",
  countryName: "Germany",
};
const fr: Language = {
  locale: "fr",
  language_name: "Français",
  flag: FRFlag,
  countryCode: "FRA",
  countryName: "France",
};
const nl: Language = {
  locale: "nl",
  language_name: "Dutch",
  flag: NLFlag,
  countryCode: "NLD",
  countryName: "Netherlands",
};
const pl: Language = {
  locale: "pl",
  language_name: "Polski",
  flag: PLFlag,
  countryCode: "POL",
  countryName: "Poland",
};
const ru: Language = {
  locale: "ru",
  language_name: "Pyccкий",
  flag: RUFlag,
  countryCode: "RUS",
  countryName: "Russia",
};

export const languages: Record<string, Language> = {
  en: enGB,
  de,
  fr,
  nl,
  pl,
  ru,
};
